import { render, staticRenderFns } from "./depositRecord.vue?vue&type=template&id=ec139dfa&scoped=true&lang=pug"
import script from "./depositRecord.vue?vue&type=script&lang=js"
export * from "./depositRecord.vue?vue&type=script&lang=js"
import style0 from "./depositRecord.vue?vue&type=style&index=0&id=ec139dfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec139dfa",
  null
  
)

export default component.exports